import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";


// COMPONENTS
import Loader from "../Loader"
import Paginate from "../../components/Shared/Paginate";
import OptionsComponent from "./OptionsComponent";
import SelectDropdown from "./SelectDropdown";
// CSS STYLES
import styles from "../../styles/Components/Shared/ListPageTable.module.css";
import ListPageSubTable from "./ListPageSubTable";
import { SlArrowDown } from "react-icons/sl";

// ICONS    
const TrashIcon = '/static/img/SvgIcons/icons-trash-black.svg';
const EditIcon = '/static/img/SvgIcons/icons-edit-pen-blue.svg';
const Ellipsis = '/static/img/SvgIcons/icons8-ellipsis.svg'



const ListPageHeaders = ({tableKeyObjects, getGridTemplate, isLarge, endColumn}) => {
    return (
        <div className={isLarge ? styles.table_large_header_container : styles.table_header_container} style={{gridTemplateColumns: `${getGridTemplate(tableKeyObjects)}`}}>
            {tableKeyObjects.map((header,i) => 
                {
                    return ( 
                        <div key={`${header.label}-${i}`} className={styles.single_header_container} style={header.label === 'Edit' || header.label === 'More' ? {alignItems: 'end'} : {}}>
                            <p>{header.label}</p>
                        </div>
                    ) 
                }
            )}

            {endColumn ? 
                endColumn
            : null}
        </div>
    )
}

const ListPageTable = ({
    // PARENT PROPS
    tableTitle,
    tableKeyObjects,
    tableData,
    tableDataExtra,
    handleChangeSelect,
    handleChangeSelectExtra,
    paginateProps,
    isLoading,
    MoreOptionsComponent,
    AddComponent,
    allowScroll,
    scrollOverflow,
    subTableKeyObject,
    showSubTable,
    subTableData,
    toggleSub,
    showOnlyOneSubTable,
    noResultsText
}) => {
    const menuRef = useRef(null);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [subTableToggle, setSubTableToggle] = useState({});
    

    const dateFormat = new Intl.DateTimeFormat('en-US', {
        timeZone: 'UTC',
        year: '2-digit',
        month: 'numeric',
        day: 'numeric'
    });

    const getGridTemplate = (dataKeyObjects) => {
        let gridFrs = dataKeyObjects.map((obj) => obj.width ? `minmax(${obj.width}, ${obj.gridFr}fr)` : ` ${obj.gridFr}fr`).join(' ')
        return gridFrs;
    }


    const getAuthors = (data, dataSource) => {
        if (!data) {
            return 'N/A'
        }


        if (dataSource === 'blogs-list' || dataSource === 'research-list' || dataSource === 'caseStudies-list' || dataSource === 'marketingMaterials-list'|| dataSource === 'ce-list' || dataSource === 'infoArticles-list' || dataSource === 'otherArticles-list') {

            let authorName = ''
            if (data.OldUser) {
                authorName = data.OldUser.first_name ? `${data.OldUser.first_name}  ${data.OldUser.last_name}` : 'N/A'
            } else if (data.User) {
                authorName = data.User.firstName ? `${data.User.firstName}  ${data.User.lastName}` : 'N/A'
            }
            return authorName
        }

        
    }


    const getManufacturers = (data, dataSource) => {
        if (!data ) {
            return 'N/A'
        } 

        let manufacturers = []
        if (dataSource === 'blogs-list' || dataSource === 'caseStudies-list' || dataSource === 'research-list' || dataSource === 'marketingMaterials-list' || dataSource === 'ce-list' || dataSource === 'infoArticles-list' || dataSource === 'otherArticles-list') {
            if (data.ArticleMaps.length === 0) {
                return 'N/A'
            } else {
                // manufacturers = data.ArticleMaps.filter((cMap) => cMap.sub_category_id)
                for (const artMaps of data.ArticleMaps) {
                    if (artMaps.Product && artMaps.Product.Manufacturer) {
                        manufacturers.push(artMaps.Product.Manufacturer)
                    }
                }
                // return data.ArticleMaps[0].Product.Manufacturer.name
                let formattedManufacturers = manufacturers.slice(0, 3).map((manufacturer, i) => {
                    let maxNameLength = 16
                    const truncatedText = manufacturer.name.substring(0, maxNameLength) + '...';
                    let ticketname = manufacturer.name.length > maxNameLength ? truncatedText : manufacturer.name
                    
                    return (
                        <p key={`category-${i}`} className={styles.regular_data}>{ticketname}</p>
                    )
                })
        
                if (manufacturers.length > 3) {
                    const extras = 
                    <div className={styles.multiple_data_wrapper} key={`extra`}>
                        <p className={styles.multiple_data_indicator}>{`+${manufacturers.length - 3} more`}</p>
                        <div className={styles.multiple_data_dropdown}>
                            {manufacturers.slice(3).map((man, i) => (
                                
                                <p key={`reg-ticket-${i}`} className={styles.regular_data}>{man?.name}</p>
                            ))}
                        </div>
                    </div>
                    
                    formattedManufacturers.push(extras)
                }
        
                if (manufacturers.length === 0) {
                    formattedManufacturers = <p className={styles.regular_data}>N/A</p>
                }
        
                return formattedManufacturers
            } 




        } else if (dataSource === 'productVideos-list') {
            let productVideoManufacturers = data?.Product?.Manufacturer ? [data.Product.Manufacturer.name] : []
         
            if (data.VideoProductMap?.length > 0) {
                for (let videoMap of data.VideoProductMap) {
                    if (videoMap?.Product?.Manufacturer && !productVideoManufacturers.includes(videoMap.Product.Manufacturer.name)) {
                        productVideoManufacturers.push(videoMap.Product.Manufacturer.name)
                    }
                }
            }

            return productVideoManufacturers?.length > 0 ? new Intl.ListFormat('en-us').format(productVideoManufacturers) : 'N/A'
          
        }


    }

    const getReviewDecription = (data, dataSource) => {
        if (!data ) {
            return <p>'N/A'</p>
        } 

        let originalDescription = data.review_description

        let maxNameLength = 120
        const limitedText = originalDescription.substring(0, maxNameLength) + '...';
        let renderDescription = originalDescription.length > maxNameLength ? limitedText : originalDescription


        if (originalDescription.length > maxNameLength) {
            const extras = 
                <div className={styles.multiple_data_wrapper}>
                    <p className={styles.multiple_data_indicator}>{`View More...`}</p>
                    <div className={styles.longtext_data_dropdown}>
                        <p>{originalDescription}</p>
                    </div>
                </div>

            renderDescription = (
                <>
                {renderDescription}
                {extras}
                </>
            )
        }

        return renderDescription
    }

    // ADVANCED EDIT OPTIONS
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setOpenMenuIndex(null);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const handleToggleSubTable = (index) => {
        const showTable = subTableToggle && subTableToggle[index] ? false : true

        setSubTableToggle(prevData => ({

            // WILL ONLY TOGGLE ONE OPEN AT A TIME IF SHOW ONLY ONE SUB TABLE IS TRUE
            ...!showOnlyOneSubTable ? { prevData } : {},

            [index]: showTable
        }))
    }

    useEffect(() => {

        // CLOSE SUB TABLES WHEN TABLE DATA CHANGES
        if (toggleSub && subTableToggle && Object.keys(subTableToggle)?.length > 0) {
            setSubTableToggle({})
        }
    }, [tableData])

    return (
        <div className={styles.eventDash_table_main_container}>
            {/* Title Row */}
            <div className={styles.table_title_row}>
                    <p className={styles.table_title}>{tableTitle}</p>
                {AddComponent ? 
                    <AddComponent isSmall={true}/>
                : null}
            </div>
            
            <div className={`${styles.table_wrapper} ${allowScroll ? styles.table_scroll : ''}`}>
                

                {/* Table Header */}
                <ListPageHeaders tableKeyObjects={tableKeyObjects} getGridTemplate={getGridTemplate} isLarge={false}/>

                {/* Data Rows */}
                {tableData.length > 0 ? (
                
                    
                    tableData.map((data, i) => (
                        <div className={styles.single_table_row} style={{gridTemplateColumns: `${getGridTemplate(tableKeyObjects)}`}} key={`table-row-${i}`}>
                            {

                                tableKeyObjects.map((dataKeyObj, idx) => {


                                        // CHECK IF COURSE IS PUBLISHED
                                        const dataSource = dataKeyObj.dataSource
                                        const isBlogPublished = dataSource === 'blogs-list' && data.publish
                                        const isCaseStudyPublished = dataSource === 'caseStudies-list' && data.publish
                                        const isResearchPublished = dataSource === 'research-list' && data.publish
                                        const isMarketingMaterialsPublished = dataSource === 'marketingMaterials-list' && data.publish
                                        const isProductVideoPublished = dataSource === 'productVideos-list' && data.published
                                        const isPodcastPublished = dataSource === 'podcasts-list' && data.publish
                                        const isContEducationPublished = dataSource === 'ce-list' && data.publish
                                        const isInfoArticlePublished = dataSource === 'infoArticles-list' && data.publish
                                        const isOtherArticlePublished = dataSource === 'otherArticles-list' && data.publish
                                        const isEvaluationPublished = dataSource === 'evaluations-list' && data.published

                                        return (
                                            // GENERIC
                                            dataKeyObj.dataKey === 'generic' ? 
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    onClick={() => dataKeyObj.callback ? dataKeyObj.callback(data): {}}
                                                    style={dataKeyObj.addedStyle ? dataKeyObj.addedStyle : {}}
                                                >
                                                    <div className={`${styles.regular_data} ${scrollOverflow ? styles.regular_data_scroll_overflow : ''} ${dataKeyObj.breakWord ? styles.regular_data_break_word : ''}`} >
                                                        {dataKeyObj.getName ? dataKeyObj.getName(data) : dataKeyObj.property ? data[dataKeyObj.property] : null }
                                                        {dataKeyObj.checkSpecial ? 
                                                            dataKeyObj.checkSpecial(data, i)
                                                        : null}
                                                    </div>
                                            </div>
                                            : dataKeyObj.label === 'Edit' || dataKeyObj.isEditOptions ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.edit_cell_container} >
                                                    {dataKeyObj.editCallback ?
                                                        <div className={styles.edit_icon_container} onClick={() => dataKeyObj.editCallback ? dataKeyObj.editCallback(data) : {}}>
                                                            <img src={EditIcon} alt="Trash Icon" />
                                                        </div>
                                                    : null}
                                                    {dataKeyObj.deleteCallback ?
                                                        <div className={styles.edit_icon_container} onClick={() => dataKeyObj.deleteCallback ? dataKeyObj.deleteCallback(data) : {}}>
                                                            <img src={TrashIcon} alt="Trash Icon" />
                                                        </div>
                                                    : null}
                                                </div>
                                            ) : dataKeyObj.advancedEditOptions ? (
                                                <OptionsComponent key={`table-cell-${i}-${idx}`} openMenuIndex={openMenuIndex} setOpenMenuIndex={setOpenMenuIndex} menuRef={menuRef} menuIndex={i} data={data} advancedEditOptions={dataKeyObj.advancedEditOptions} addedStyle={dataKeyObj.addedStyle} />

                                                // <div className={styles.edit_options_container} key={`advanced-${idx}`}>
                                                //     <img src={Ellipsis} alt={'Edit Options'} width={20} height={20} />
                                                //         <div className={styles.edit_options}>
                                                //         {dataKeyObj.advancedEditOptions.map((option, i) => !(option.hideOption && option.hideOption(data)) ? (
                                                //             <div key={`edit-option-${i}`}>
                                                //                 <p  className={(option.disabled || option.checkDisabled && option.checkDisabled(data)) ? styles.disabled_option : ''}
                                                //                     onClick={() => {
                                                //                         if (option.disabled || option.checkDisabled && option.checkDisabled(data)) {
                                                //                             return
                                                //                         }
                                                                        
                                                //                         return option.cb ? option.cb(data) : {}}}
                                                //                 >
                                                //                     {option.getName ? option.getName(data) : option.name}
                                                //                 </p>
                                                //             </div>
                                                //         )
                                                //         : null)}
                                                //     </div>
                                                // </div>



                                                // MORE OPTIONS COMPONENT FOR MORE OPTIONS COLUMN
                                                // MORE OPTIONS COMPONENT FOR MORE OPTIONS COLUMN
                                                // MORE OPTIONS COMPONENT FOR MORE OPTIONS COLUMN
                                            ) : dataKeyObj.label === 'More' && dataKeyObj.dataKey === 'more-options-component' && MoreOptionsComponent  ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.edit_cell_container} >
                                                    <MoreOptionsComponent menuIndex={i} data={data} />
                                                </div>

                                            ) : dataKeyObj.dataKey === 'sub-table-toggle' ? (
                                                <div key={`sub-toggle-${i}-${idx}`} onClick={() => handleToggleSubTable(i)} className={subTableToggle && subTableToggle[i] ? styles.toggle_arrow_hide :styles.toggle_arrow_show}>
                                                    <div></div>
                                                    <SlArrowDown size={15} style={{zIndex:50, position:'relative'}}/>
                                                    {/* {subTableToggle && subTableToggle[i] ? 'Hide' : 'Show'} */}
                                                </div>

                                                // BLOGS LIST PAGE
                                                // BLOGS LIST PAGE
                                                // BLOGS LIST PAGE
                                            ) : dataKeyObj.dataKey === 'blogsListTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.title ? data.title : 'N/A'}
                                                        {!isBlogPublished && <span style={{color: 'red'}}>*</span>}
                                                    </p>
                                                </div>
                                            ) :  dataKeyObj.dataKey === 'blogsListTable-userName' ?(
                                                    <div className={styles.multiple_data_container} key={`table-cell-${i}-${idx}`}>
                                                        {data.userName ? data.userName : 'N/A'}
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'blogsListTable-postDate' ?(
                                                    <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                        <p className={styles.regular_data}>
                                                            {dateFormat.format(new Date(data.createDate))}
                                                        </p>
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'blogsListTable-published' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {isBlogPublished ? 'Yes' : 'No'}
                                                    </p>
                                                </div>



                                                // CASE-STUDY LIST PAGE
                                                // CASE-STUDY LIST PAGE
                                                // CASE-STUDY LIST PAGE
                                            ) : dataKeyObj.dataKey === 'caseStudiesListTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.title ? data.title : 'N/A'}
                                                        {!isCaseStudyPublished && <span style={{color: 'red'}}>*</span>}
                                                    </p>
                                                </div>
                                            ) :  dataKeyObj.dataKey === 'caseStudiesListTable-author' ?(
                                                    <div className={styles.multiple_data_container} key={`table-cell-${i}-${idx}`}>
                                                        <p className={styles.regular_data}>
                                                            {getAuthors(data, dataSource)}
                                                        </p>
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'caseStudiesListTable-manufacturer' ?(
                                                    <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                        <div className={styles.regular_data}>
                                                            {getManufacturers(data, dataSource)}
                                                        </div>
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'caseStudiesListTable-postDate' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {dateFormat.format(new Date(data.create_date))}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'caseStudiesListTable-published' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {isCaseStudyPublished ? 'Yes' : 'No'}
                                                    </p>
                                                </div>

                                                // RESEARCH ARTICLES LIST PAGE
                                                // RESEARCH ARTICLES LIST PAGE
                                                // RESEARCH ARTICLES LIST PAGE

                                            ) : dataKeyObj.dataKey === 'researchListTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.title ? data.title : 'N/A'}
                                                        {!isResearchPublished && <span style={{color: 'red'}}>*</span>}
                                                    </p>
                                                </div>
                                            ) :  dataKeyObj.dataKey === 'researchListTable-author' ?(
                                                    <div className={styles.multiple_data_container} key={`table-cell-${i}-${idx}`}>
                                                        <p className={styles.regular_data}>
                                                            {getAuthors(data, dataSource)}
                                                        </p>
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'researchListTable-manufacturer' ?(
                                                    <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                        <div className={styles.regular_data}>
                                                            {getManufacturers(data, dataSource)}
                                                        </div>
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'researchListTable-postDate' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {dateFormat.format(new Date(data.create_date))}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'researchListTable-published' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {isResearchPublished ? 'Yes' : 'No'}
                                                    </p>
                                                </div>



                                                // MARKETING MATERIALS LIST PAGE
                                                // MARKETING MATERIALS LIST PAGE
                                                // MARKETING MATERIALS LIST PAGE

                                            ) : dataKeyObj.dataKey === 'marketingMaterialsListTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.title ? data.title : 'N/A'}
                                                        {!isMarketingMaterialsPublished && <span style={{color: 'red'}}>*</span>}
                                                    </p>
                                                </div>
                                            ) :  dataKeyObj.dataKey === 'marketingMaterialsListTable-author' ?(
                                                    <div className={styles.multiple_data_container} key={`table-cell-${i}-${idx}`}>
                                                        <p className={styles.regular_data}>
                                                            {getAuthors(data, dataSource)}
                                                        </p>
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'marketingMaterialsListTable-manufacturer' ?(
                                                    <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                        <div className={styles.regular_data}>
                                                            {getManufacturers(data, dataSource)}
                                                        </div>
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'marketingMaterialsListTable-postDate' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {dateFormat.format(new Date(data.create_date))}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'marketingMaterialsListTable-published' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {isMarketingMaterialsPublished ? 'Yes' : 'No'}
                                                    </p>
                                                </div>


                                                //  PRODUCT VIDEOS LIST PAGE
                                                //  PRODUCT VIDEOS LIST PAGE
                                                //  PRODUCT VIDEOS LIST PAGE

                                            ) : dataKeyObj.dataKey === 'productVideosListTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.name ? data.name : 'N/A'}
                                                        {!isProductVideoPublished && <span style={{color: 'red'}}>*</span>}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'productVideosListTable-manufacturer' ?(
                                                    <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                        <div className={styles.regular_data}>
                                                            {getManufacturers(data, dataSource)}
                                                        </div>
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'productVideosListTable-postDate' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {dateFormat.format(new Date(data.create_date))}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'productVideosListTable-published' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {isProductVideoPublished ? 'Yes' : 'No'}
                                                    </p>
                                                </div>


                                                //  PODCASTS LIST PAGE
                                                //  PODCASTS LIST PAGE
                                                //  PODCASTS LIST PAGE

                                            ) : dataKeyObj.dataKey === 'podcastListTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.name ? data.name : 'N/A'}
                                                        {!isPodcastPublished && <span style={{color: 'red'}}>*</span>}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'podcastListTable-manufacturer' ?(
                                                    <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                        <div className={styles.regular_data}>
                                                            {getManufacturers(data, dataSource)}
                                                        </div>
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'podcastListTable-postDate' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {dateFormat.format(new Date(data.create_date))}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'podcastListTable-published' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {isPodcastPublished ? 'Yes' : 'No'}
                                                    </p>
                                                </div>








                                                //  CONTINUIN EDUCATION LIST PAGE
                                                //  CONTINUIN EDUCATION LIST PAGE
                                                //  CONTINUIN EDUCATION LIST PAGE

                                            ) : dataKeyObj.dataKey === 'ceListTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.title ? data.title : 'N/A'}
                                                        {!isContEducationPublished && <span style={{color: 'red'}}>*</span>}
                                                    </p>
                                                </div>
                                            ) :  dataKeyObj.dataKey === 'ceListTable-author' ?(
                                                <div className={styles.multiple_data_container} key={`table-cell-${i}-${idx}`}>
                                                    <p className={styles.regular_data}>
                                                        {getAuthors(data, dataSource)}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'ceListTable-manufacturer' ?(
                                                    <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                        <div className={styles.regular_data}>
                                                            {getManufacturers(data, dataSource)}
                                                        </div>
                                                    </div>
                                            ) : dataKeyObj.dataKey === 'ceListTable-postDate' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {dateFormat.format(new Date(data.create_date))}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'ceListTable-published' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {isContEducationPublished ? 'Yes' : 'No'}
                                                    </p>
                                                </div>








                                                //  INFO ARTICLES PAGE
                                                //  INFO ARTICLES PAGE
                                                //  INFO ARTICLES PAGE

                                            ) : dataKeyObj.dataKey === 'infoArticlesListTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.title ? data.title : 'N/A'}
                                                        {!isInfoArticlePublished && <span style={{color: 'red'}}>*</span>}
                                                    </p>
                                                </div>
                                            ) :  dataKeyObj.dataKey === 'infoArticlesListTable-author' ?(
                                                <div className={styles.multiple_data_container} key={`table-cell-${i}-${idx}`}>
                                                    <p className={styles.regular_data}>
                                                        {getAuthors(data, dataSource)}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'infoArticlesListTable-postDate' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {dateFormat.format(new Date(data.create_date))}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'infoArticlesListTable-published' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {isInfoArticlePublished ? 'Yes' : 'No'}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'infoArticlesListTable-manufacturer' ?(
                                                    <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                        <div className={styles.regular_data}>
                                                            {getManufacturers(data, dataSource)}
                                                        </div>
                                                    </div>
                

                                                //  OTHER ARTICLES LIST PAGE
                                                //  OTHER ARTICLES LIST PAGE
                                                //  OTHER ARTICLES LIST PAGE
                                            ) : dataKeyObj.dataKey === 'otherArticlesListTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.title ? data.title : 'N/A'}
                                                        {!isOtherArticlePublished && <span style={{color: 'red'}}>*</span>}
                                                    </p>
                                                </div>
                                            ) :  dataKeyObj.dataKey === 'otherArticlesListTable-author' ?(
                                                <div className={styles.multiple_data_container} key={`table-cell-${i}-${idx}`}>
                                                    <p className={styles.regular_data}>
                                                        {getAuthors(data, dataSource)}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'otherArticlesListTable-manufacturer' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <div className={styles.regular_data}>
                                                        {getManufacturers(data, dataSource)}
                                                    </div>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'otherArticlesListTable-postDate' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {dateFormat.format(new Date(data.create_date))}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'otherArticlesListTable-published' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {isOtherArticlePublished ? 'Yes' : 'No'}
                                                    </p>
                                                </div>


                                                //  EVALUATIONS LIST PAGE
                                                //  EVALUATIONS LIST PAGE
                                                //  EVALUATIONS LIST PAGE
                                            ) : dataKeyObj.dataKey === 'evaluationListTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.Product.name ? data.Product.name : 'N/A'}
                                                        {!isEvaluationPublished && <span style={{color: 'red'}}>*</span>}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'evaluationListTable-category' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {data.Product.Category ? data.Product.Category.name : 'N/A'}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'evaluationListTable-postDate' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {dateFormat.format(new Date(data.create_date))}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'evaluationListTable-published' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {isEvaluationPublished ? 'Yes' : 'No'}
                                                    </p>
                                                </div>


                                                //  CRITERIA LIST PAGE
                                                //  CRITERIA LIST PAGE
                                                //  CRITERIA LIST PAGE
                                            ) : dataKeyObj.dataKey === 'criteriaListTable-id' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.criteria_id ? data.criteria_id : 'N/A'}
                                                    </p>
                                                </div>
                                            ) : dataKeyObj.dataKey === 'criteriaListTable-name' ?(
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {data.criteriaName ? data.criteriaName : 'N/A'}
                                                    </p>
                                                </div>


                                                //  MANUFACTURER REVIEWS - REVIEWS PAGE
                                                //  MANUFACTURER REVIEWS - REVIEWS PAGE
                                                //  MANUFACTURER REVIEWS - REVIEWS PAGE
                                            ) : dataKeyObj.dataKey === 'manReview-manufacturer' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.Manufacturer ? data.Manufacturer.name : 'N/A'}
                                                    </p>
                                                </div>

                                            ) : dataKeyObj.dataKey === 'manReview-title' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {data.review_title ? data.review_title : 'N/A'}
                                                    </p>
                                                </div>

                                            
                                            ) : dataKeyObj.dataKey === 'manReview-description' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    {/* <p className={styles.regular_data}>
                                                        {data.review_title ? data.review_title : 'N/A'}
                                                    </p> */}
                                                    {data.review_description? getReviewDecription(data, dataSource) : 'N/A'}
                                                </div>


                                            ) : dataKeyObj.dataKey === 'manReview-author' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {data.user_name ? data.user_name : 'N/A'}
                                                    </p>
                                                </div>

                                            ) : dataKeyObj.dataKey === 'manReview-postDate' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {/* {data.created_date ? data.created_date : 'N/A'} */}
                                                        {dateFormat.format(new Date(data.created_date))}
                                                    </p>
                                                </div>


                                            ) : dataKeyObj.dataKey === 'manReview-approved' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {data.review_approved ? 'Yes' : 'No'}
                                                    </p>
                                                </div>



                                                //  PRODUCT REVIEWS - REVIEWS PAGE
                                                //  PRODUCT REVIEWS - REVIEWS PAGE
                                                //  PRODUCT REVIEWS - REVIEWS PAGE
                                            ) : dataKeyObj.dataKey === 'prodReview-productName' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                    // onClick={() => callback && dataKeyObj.modalView ? callback(data, dataKeyObj.modalView): {}}
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.Product ? data.Product.name : 'N/A'}
                                                    </p>
                                                </div>

                                            ) : dataKeyObj.dataKey === 'prodReview-title' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {data.review_title ? data.review_title : 'N/A'}
                                                    </p>
                                                </div>

                                            ) : dataKeyObj.dataKey === 'prodReview-description' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    {/* <p className={styles.regular_data}>
                                                        {data.review_title ? data.review_title : 'N/A'}
                                                    </p> */}
                                                    {data.review_description? getReviewDecription(data, dataSource) : 'N/A'}
                                                </div>

                                            ) : dataKeyObj.dataKey === 'prodReview-manufacturer' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {data.Product && data.Product.Manufacturer ? data.Product.Manufacturer.name : 'N/A'}
                                                    </p>
                                                </div>


                                            ) : dataKeyObj.dataKey === 'prodReview-author' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {data.user_name ? data.user_name : 'N/A'}
                                                    </p>
                                                </div>

                                            ) : dataKeyObj.dataKey === 'prodReview-postDate' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {/* {data.created_date ? data.created_date : 'N/A'} */}
                                                        {dateFormat.format(new Date(data.created_date))}
                                                    </p>
                                                </div>


                                            ) : dataKeyObj.dataKey === 'prodReview-approved' ? (
                                                <div key={`table-cell-${i}-${idx}`} className={styles.regular_data_container} >
                                                    <p className={styles.regular_data}>
                                                        {data.review_approved ? 'Yes' : 'No'}
                                                    </p>
                                                </div>





                                                //  MANAGE USERS PAGE - ADMIN PAGES
                                                //  MANAGE USERS PAGE - ADMIN PAGES
                                                //  MANAGE USERS PAGE - ADMIN PAGES
                                            ) : dataKeyObj.dataKey === 'activeUsersTable-name' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.firstName ? `${data.firstName} ${data.lastName}` : 'N/A'}
                                                    </p>
                                                </div>

                                            ) : dataKeyObj.dataKey === 'activeUsersTable-email' ? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                >
                                                    <p className={styles.regular_data} >
                                                        {data.email ? `${data.email}` : 'N/A'}
                                                    </p>
                                                </div>

                                            ) : dataKeyObj.dataKey === 'activeUsersTable-role' && tableDataExtra? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                >
                                                    <div className={`input_container ${styles.form_grid_span_5}`}>
                                                        <label>Role</label>
                                                        <SelectDropdown 
                                                            options={tableDataExtra.map((role) => ({ name: role.name, value: role.id, data: role }))}
                                                            placeholder={'Select Order'} 
                                                            handleSelect={(option) => handleChangeSelect(option, data.id )}
                                                            selection={data.Role.id}
                                                            returnData={true}
                                                        />
                                                    </div> 
                                                </div>

                                            

                                            ) : dataKeyObj.dataKey === 'activeUsersTable-published' && tableDataExtra? (
                                                <div 
                                                    key={`table-cell-${i}-${idx}`}     
                                                    className={styles.regular_data_container} 
                                                >
                                                    <div className={`input_container ${styles.form_grid_span_5}`}>
                                                        <label>Status</label>
                                                        <SelectDropdown 
                                                            options={[
                                                                {
                                                                    name: 'Active',
                                                                    value: true,
                                                                },
                                                                {
                                                                    name: 'Inactive',
                                                                    value: false,
                                                                }
                                                            ]}
                                                            placeholder={'Select Status'} 
                                                            handleSelect={(option) => handleChangeSelectExtra(option, data.id )}
                                                            selection={data.status}
                                                        />
                                                    </div> 
                                                </div>

                                            

                                            )  :(
                                                <div></div>
                                            )



                                        )
                                        
                                        
                                        
                                        


                                })
                            }

                            {subTableKeyObject && showSubTable && subTableData && showSubTable(data) && (!toggleSub || (subTableToggle && subTableToggle[i])) ? 
                                <div className={`${styles.sub_table_wrapper}`}>

                                    <ListPageSubTable 
                                        tableKeyObjects={subTableKeyObject}
                                        tableData={subTableData(data)}
                                        menuRef={menuRef}
                                        index={i}
                                        openMenuIndex={openMenuIndex}
                                        setOpenMenuIndex={setOpenMenuIndex}
                                    />
                                </div>
                            : null}
                        </div>
                    ))

           
                ) : isLoading ? ( 
                    <div className={styles.eventDash_table_loader_container}>
                        <Loader />
                        <p>Data is Loading...</p>
                    </div>
                ) : !isLoading && tableData.length === 0 && (
                    <div className={styles.eventDash_table_loader_container}>
                        <p>{noResultsText ? noResultsText : 'No Data Available for this query...'}</p>
                    </div>
                )}

            </div>
            {/* PAGINATION */}
            {
                paginateProps ? (
                    <Paginate 
                        paginateProps={paginateProps}
                    />
                ) : (null)
            }
        </div>
    ) 

};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {
})(ListPageTable);



